import React, { useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { Card, Button, Space, Row } from "@masterteam/mt-design-react";
import UserInfo from "../../../UserInfo";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/delete.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/edit.svg";
import CommentInput from "../CommentInput";
import api from "../../../../providers/api";
import { addToast } from "../../../../helpers";

import styles from "./Comment.module.scss";

function Comment({ item, KPIDetails, getData, callback }) {
  const currentUser = useSelector(({ user }) => user.user);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleDelete() {
    setLoading(true);
    api.kpi
      .deleteComment(item.ID)
      .then(res => {
        const { StatusCode } = res;
        if (StatusCode === "Success") {
          addToast.success("toast.successDelete");
          callback(item, "deleteComment");
        }
      })
      .catch(err => {
        addToast.error(err.message, {
          toastId: "get-users-error"
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <Card className={styles.comment}>
      <Space direction="vertical" size="medium">
        <Row justify="between">
          <UserInfo
            item={item.CreatedByModel}
            title={moment(item.Created).format("DD/MM/YYYY, h:mm:ss a")}
            style={{
              height: 35,
              width: 35
            }}
          />
          {currentUser?.UserName === item?.CreatedByModel?.UserName && (
            <Space className="actions">
              <Button
                fill="none"
                variant="error"
                shape="square"
                onClick={handleDelete}
                Icon={DeleteIcon}
                loading={loading}
              />
              <Button
                fill={editMode ? "full" : "none"}
                shape="square"
                onClick={() => {
                  setEditMode(!editMode);
                }}
                Icon={EditIcon}
              />
            </Space>
          )}
        </Row>
        <div className="comment-data">
          {editMode ? (
            <CommentInput
              data={item}
              callback={(item, action) => {
                setEditMode(false);
                callback(item, action);
              }}
              KPIDetails={KPIDetails}
              getData={getData}
            />
          ) : (
            <b>{item.Comment}</b>
          )}
        </div>
      </Space>
    </Card>
  );
}

export default Comment;
